





























import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'

settings = 
  name: 'OnsiteInfoStep'
  vue:
    mixins: [WizardService.step()]
    components: { RequestButton }
    computed:
      primaryContact: -> 
        if !@wizard.prime.advance.brand_onsite_contacts.length
          @wizard.prime.advance.brand_onsite_contacts.push {}
        @wizard.prime.advance.brand_onsite_contacts[0]
      secondaryContact: -> 
        if @wizard.prime.advance.brand_onsite_contacts.length < 2
          @wizard.prime.advance.brand_onsite_contacts.push {}
        @wizard.prime.advance.brand_onsite_contacts[1]
    methods:
      validateStep: -> return true
      saveFields: -> advance: ['brand_onsite_contacts', 'offer_overrides'] 



export default VueOptions.vue settings
